import DisplayPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/singleLineInput/components/SingleLineInputDisplayPart';
import FormPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/singleLineInput/components/SingleLineInputFormPart';

export default {
  DisplayPart,
  FormPart,
};
